import React, { Fragment } from "react"
import { PLACES } from "./constants"

const WEEKS = ["1a settimana", "2a settimana", "3a settimana", "4a settimana", "5a settimana"]
const DAYS = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì"]
const SLICES_ORIGINAL = ["pre", "post"]

const GroupTable = ({ state, week, prePostMode }) => {
  const slices = SLICES_ORIGINAL.filter(slice => slice === prePostMode || prePostMode === "both")
  return (
    <table 
      style={{ width: "100%", borderCollapse: "collapse", marginTop: 15, tableLayout: "fixed" }}
      className={`custom-table mode-${prePostMode}`}
    >
      <thead>
        <tr>
          <th />
          {WEEKS.filter(w => w === week).map(w => (
            <th colSpan={DAYS.length * slices.length} key={w}>{w}</th>
          ))}
        </tr>
        <tr>
          <th />
          {WEEKS.filter(w => w === week).map(w => (
            <Fragment key={w}>
              {DAYS.map(d => (
                <th colSpan={slices.length} key={d}>{d}</th>
              ))}
            </Fragment>
          ))}
        </tr>
        <tr>
          <th />
          {WEEKS.filter(w => w === week).map(w => (
            <Fragment key={w}>
              {DAYS.map(d => (
                <Fragment key={d}>
                  {slices.map(sl => (
                    <th key={sl}>{sl}</th>
                  ))}
                </Fragment>
              ))}
            </Fragment>
          ))}
        </tr>
      </thead>
      <tbody>
        {PLACES.map(p => (
          <tr key={p.name}>
            <th>{p.name}</th>
            {WEEKS.filter(w => w === week).map(w => (
              <Fragment key={w}>
                {DAYS.map(d => (
                  <Fragment key={d}>
                    {slices.map(sl => {
                      const records = state.filter(record => record.space === p.name && record.week === w && record.day === d && record.slice === sl)
                      return (
                        <td key={sl}>
                          {records.map((r, i) => (
                            <div key={i}>{r.group}</div>
                          ))}
                        </td>
                      )
                    })}
                  </Fragment>
                ))}
              </Fragment>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default GroupTable